<template>
    <div>
        <b-container class="" fluid> 
            <b-row>
                <b-col class="">
                    <h4 class="">Test Scores</h4>
                    <b-skeleton-wrapper class="text-center" :loading="loading">
                        <template #loading>
                            <b-skeleton width="100%"></b-skeleton>
                        </template>
                        <h6 class="">{{  meta?.total }} Test{{ meta?.total > 1 ? 's' : '' }} taken</h6>
                    </b-skeleton-wrapper>

                </b-col>
            </b-row>
            <b-row>
                <b-col class="m-0 p-1" style="overflow-x: scroll">
                    <div class="list-heads text-center pt-2">
                        <p class="head-p">S/N</p>
                        <p class="head-p">Category</p>
                        <p class="head-p">Institution</p>
                        <p class="head-p">Mode</p>
                        <p class="head-p">Score</p>
                        <p class="head-p"></p>
                    </div>

                    <b-skeleton-wrapper class="text-center mt-3" :loading="loading">
                        <template #loading>
                        <b-skeleton width="100%"></b-skeleton>
                        <b-skeleton width="80%"></b-skeleton>
                        <b-skeleton width="90%"></b-skeleton>
                        <b-skeleton width="100%" class="mt-3"></b-skeleton>
                        <b-skeleton width="80%"></b-skeleton>
                        <b-skeleton width="90%"></b-skeleton>
                        <b-skeleton width="100%" class="mt-3"></b-skeleton>
                        <b-skeleton width="80%"></b-skeleton>
                        <b-skeleton width="100%"></b-skeleton>
                        <b-skeleton width="100%" class="mt-3"></b-skeleton>
                        <b-skeleton width="80%"></b-skeleton>
                        <b-skeleton width="100%"></b-skeleton>
                        <b-skeleton width="100%" class="mt-3"></b-skeleton>
                        <b-skeleton width="80%"></b-skeleton>
                        <b-skeleton width="90%"></b-skeleton>
                        <b-skeleton width="100%" class="mt-3"></b-skeleton>
                        <b-skeleton width="80%"></b-skeleton>
                        <b-skeleton width="100%"></b-skeleton>

                        </template>
                    </b-skeleton-wrapper>

                    <div v-if="!loading">
                        <maxi-results class="mt-2 maxres" v-for="(result, index) in useresultsarray" :sn="index + 1" :result="result" :key="index" :page="pages" :interval='intervalnum'></maxi-results>
                        <paginater
                            :intervalnum="intervalnum"
                            :pages="pages"
                            :meta="meta"
                            :endnum="meta?.perPage * pages"
                            :endss="endss"
                            :datalength="endss"
                            @paginator="newPage"
                            @changeInterval="effectInterval"
                        ></paginater>
                    </div>
                    
                    
                    
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import maxiResults from "@/components/maxiResults";
    import Paginater from "@/components/Paginater";

    import {
        mapState,
        mapActions
    } from "vuex";
    
    export default {
        components: {
            maxiResults,
            Paginater
        },
        data() {
            return {
                startnum: 0,
                limitnum: this.endss,
                intervalnum: 10,
                endnum: 10,
                pages: 1,
                meta: {},
                useresultsarray: [],
                loading: false
            };
        },
        watch:{
            pages(){
                this.fetchResults();
            },
            intervalnum(){
                this.fetchResults();
            }
        },  
        mounted(){
            this.fetchResults()
        },
        methods: {
            ...mapActions("dashboard", ["getmaxiresults"]),
            async fetchResults() {

                this.loading = true;

                try {
                    const response = await this.getmaxiresults(`page=${this.pages}&perPage=${this.intervalnum}`);
                    this.useresultsarray = response.data.data;
                    // this.leaderboardTable = response?.data?.data.current_board
                    this.meta = response.data.meta

                    console.log(response)

                    this.loading = false;
                } catch (err) {
                    console.log(err);
                } finally {
                    this.loading = false
                }
            },
            newPage(page) {
                this.pages = page;
            },
            effectInterval(newinterval) {
                this.intervalnum = newinterval;
                this.pages = 1;
                this.newPage(this.pages);
            },
        },
    
        computed: {
            ...mapState({
                resultsarr: state => state.dashboard.mlresults
            }),
            endss() {
                let end = this.meta?.total;
                return end;
            }
        }
    };
</script>

<style scoped>
.allrewr {
    min-height: 70vh;
    background-color: white;
    border-radius: 20px 20px;
}

.list-heads {
    background-color: #00984A;
    color: white;
    border-radius: 5px 5px;
    font-weight: bold;
    display: flex;
    flex-flow: row nowrap;
}

.viewmore {
    background-color: rgb(241, 234, 234);
    border-radius: 100px;
    width: 50px;
    height: 50px;
    margin: 0px auto;
    box-shadow: 5px 5px 15px black;
    cursor: pointer;
}

.maxres {
    border-radius: 5px 5px;
}

.maxres:hover {
    background-color: #eeeeee;
}

.vmore {
    margin: 5px;
    padding: 10px;
}

.spinver {
    width: 7rem;
    height: 7rem;
}
.head-p{
    width: 25%;
}

.page-buttons{
    width: 35px;
    height: 35px;
}
.active-page-btn{
    background-color: #00377b;
    color: white;
}
.button-pager-group{
    overflow-x:auto;
    scroll-behavior: smooth;
    scrollbar-width: thin;
}

@media screen and (max-width: 999px) {
     .head-p{
        font-size: 0.75rem
    }
    .page-buttons{
        width: 25px;
        height: 25px;
        padding: 0px 0px 0px 5px ;
    }
}
</style>
